import { render } from "./AdminMonitors.vue?vue&type=template&id=29212dc8&scoped=true"
import script from "./AdminMonitors.vue?vue&type=script&lang=js"
export * from "./AdminMonitors.vue?vue&type=script&lang=js"

import "./AdminMonitors.vue?vue&type=style&index=0&id=29212dc8&lang=css"
import "./AdminMonitors.vue?vue&type=style&index=1&id=29212dc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29212dc8"]])

export default __exports__